import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { configurationApi } from "~/api";
import { getErrorMessage } from "~/hooks/helpers";
import type { Folder } from "~/types/api";

export const folderKeys = {
  byBrand: (brandId: number) =>
    configurationApi.queryOptions("get", "/api/brand/{brandId}/Folder", {
      params: { path: { brandId } },
    }).queryKey,
};

const fetchFolders = async (brandId: number): Promise<Folder[]> => {
  const response = await configurationApi.client.GET("/api/brand/{brandId}/Folder", {
    params: { path: { brandId } },
  });

  if (response?.error) {
    const error = getErrorMessage(response.error, "Failed to fetch folders");
    throw new Error(error);
  }
  if (response?.response?.status < 200 || response?.response?.status > 299) {
    throw new Error("Unexpected response status: " + response.response.status);
  }

  return response.data || [];
};

export const useFoldersQuery = (
  brandId: number,
  options?: Omit<UseQueryOptions<Folder[], Error>, "queryKey" | "queryFn">
) => {
  return useQuery<Folder[], Error>({
    queryKey: folderKeys.byBrand(brandId),
    queryFn: () => fetchFolders(brandId),
    retry: 1,
    meta: {
      errorTitle: "Failed to load folders",
    },
    ...options,
  });
};
